const DpoZruseniEditace = {
    init: function () {
        const buttonCancel = $("#page-header-buttons").find(".btn-secondary");

        const timestamp = Math.floor(Date.now() / 1000);
        const cancelConfirmed = localStorage.getItem("cancelConfirmed");

        if (cancelConfirmed && parseInt(cancelConfirmed) > timestamp - 10) {
            return;
        }

        if (!buttonCancel.length) {
            return;
        }

        const url = window.location.href;
        if (url.indexOf("/section/zadosti/item/edit/") < 0) {
            return;
        }

        buttonCancel
            .off("click")
            .on("click", function (e) {
                e.preventDefault();

                let text = '<div class="text-center">';
                text += '<i class="fa fa-exclamation-triangle fa-fw fa-5x mt-3 mb-4 text-danger"></i>';
                text += "</div>";
                text += '<p class="text text-center font-weight-bold" style="font-size: 1.1rem">';
                text += "Opravdu chcete odejít?<br>Neuložené informace budou ztraceny.";
                text += "</p>";

                WilleModal.setId("modal-upozorneni");
                WilleModal.disableClose();
                WilleModal.setTitle('Upozornění');
                WilleModal.setContent(text);
                WilleModal.addButton("confirmYes", "<i class=\"fa fa-fw fa-check\"></i> Ano", "btn btn-danger", function() {
                    localStorage.setItem("cancelConfirmed", timestamp.toString());

                    Promise.all([
                        WilleModal.close()
                    ]).then(() => {
                        buttonCancel.off("click");

                        let url = window.location.protocol + "//" + window.location.host;
                        url += buttonCancel.attr("href");

                        window.location = url;
                    }).catch((messages) => {
                        console.log(messages);
                    });
                });
                WilleModal.addButton("confirmNo", "<i class=\"fa fa-fw fa-check\"></i> Ne", "btn btn-primary", function() {
                    localStorage.setItem("cancelConfirmed", timestamp.toString());

                    Promise.all([
                        WilleModal.close()
                    ]).then(() => {

                    }).catch((messages) => {
                        console.log(messages);
                    });
                });
                WilleModal.build();
            });
    }
}

$(document).ready(function () {
    DpoZruseniEditace.init();
});